// extracted by mini-css-extract-plugin
export default {"tabs":"page_tabs__haUoe","dashboard":"page_dashboard__0apyX","description":"page_description__9kF06"};